module.exports = __webpack_public_path__ + "static/media/feedback.ec5fc9d5.svg";